import { useEffect, useRef, useState } from "react";
import { Bell } from "lucide-react";
import api from "../lib/api";
import { debugLog } from "../lib/logger";

export default function NotificationBell() {
  const [notices, setNotices] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get("/notices").then((r) => setNotices(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);

  const dismiss = async (id) => {
    setNotices((n) => n.filter((x) => x.notice_id !== id));
    try { await api.post(`/notices/${id}/dismiss`); } catch (e) { debugLog("dismiss notice failed", e); }
  };
  const dismissAll = async () => {
    setNotices([]);
    try { await api.post("/notices/dismiss-all"); } catch (e) { debugLog("dismiss all notices failed", e); }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} aria-label="Notifications" data-testid="notification-bell"
        className="relative flex items-center text-muted-s hover:!text-[#E8E6E1] transition-colors duration-150">
        <Bell size={18} strokeWidth={1.5} />
        {notices.length > 0 && (
          <span data-testid="notification-count"
            className="absolute -top-2 -right-2 min-w-[16px] h-4 px-1 flex items-center justify-center text-[10px] fig"
            style={{ background: "#C7A24B", color: "#0E1012", borderRadius: "8px" }}>
            {notices.length}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notification-dropdown"
          className="absolute right-0 mt-3 w-80 z-50 p-4 max-h-96 overflow-y-auto"
          style={{ background: "#14171A", border: "1px solid #24272B" }}>
          <div className="flex items-center justify-between mb-2">
            <span className="t-label">Notices</span>
            {notices.length > 0 && (
              <button onClick={dismissAll} className="t-cap text-muted-s hover:!text-[#E8E6E1]" data-testid="dismiss-all-notices">Mark all read</button>
            )}
          </div>
          {notices.length === 0 ? (
            <p className="t-small text-muted-s py-4">You are all caught up.</p>
          ) : (
            notices.map((n) => (
              <div key={n.notice_id} className="hairline py-3" data-testid={`bell-notice-${n.notice_id}`}>
                <div className="flex justify-between gap-3">
                  <span className="t-small text-bone">{n.title}</span>
                  <button onClick={() => dismiss(n.notice_id)} className="t-cap text-muted-s hover:!text-[#E8E6E1] whitespace-nowrap" data-testid={`bell-dismiss-${n.notice_id}`}>Read</button>
                </div>
                <p className="t-cap text-muted-s mt-1 measure">{n.body}</p>
                <p className="t-cap text-muted-s mt-1 fig">{n.created_at?.slice(0, 10)}</p>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
